import React from "react";

const stylePadding = {
  xs: "py-0.5  px-2",
  "xs-sm": "py-1 px-2",
  sm: "py-1.5 px-2",
  md: "p-2",
  lg: "p-3",
  xl: "p-4",
};

const styleRounded = {
  xs: "rounded-md",
  "xs-sm": "rounded-md",
  sm: "rounded-md",
  md: "rounded",
  lg: "rounded-lg",
  xl: "rounded-xl",
};

const DetailCard = ({
  title = "title",
  children,
  headeRight,
  color = "primary", // primary, warning, success, danger, info, black, white
  size = "md", // xs, xs-sm, sm, md, lg, xl
  className,
}) => {
  return (
    <div
      className={`w-full flex flex-col ${styleRounded[size]}  overflow-hidden ${className}`}
      style={{
        boxShadow: "0 6px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        className={`flex justify-between gap-2 items-center 
          
          ${
            color === "white" || color === "black"
              ? `bg-${color}`
              : `bg-${color}-50`
          } 
          
          ${stylePadding[size]}`}
      >
        <div>{typeof title === "string" ? title : title}</div>
        <div>{headeRight}</div>
      </div>
      <div className={`${stylePadding[size]} ${className} min-h-4`}>
        {children}
      </div>
    </div>
  );
};

export default DetailCard;
